import React, { useState, Suspense, lazy } from 'react';
import './../styles/Reports.css';
import { FaChartBar, FaWaveSquare } from 'react-icons/fa';
import { MdMiscellaneousServices } from "react-icons/md";
import { TbLicense } from "react-icons/tb";
import { UserType } from './../constants/userType';
import { useAuth } from './../context/AuthContext';

const LicenceReport = lazy(() => import('./reports/LicenceReport'));
const DeviceTable = lazy(() => import('./DeviceTable'));
const DailyReportPage = lazy(() => import('./reports/DailyReportPage'));
const SOTReportPage = lazy(() => import('./reports/SOTReportPage'));
const RecordsAuditReportPage = lazy(() => import('./reports/RecordsAuditReportPage'));
const MonitoringServiceReportPage = lazy(() => import('./reports/MonitoringServiceReportPage'));

const Reports = () => {
  const [currentTab, setCurrentTab] = useState('devices');
  const { userType } = useAuth();
  const isPoliceUser = userType === UserType.POLICE;

  return (
    <div className="report-container">
      <div className="tab-bar">
        <button className={currentTab === 'devices' ? 'active' : ''} onClick={() => setCurrentTab('devices')}>
          <FaWaveSquare className='reports-font-style-dark'/> Device Heartbeat
        </button>
        {!isPoliceUser && (  
          <>
            {/* <button className={currentTab === 'licenceReport' ? 'active' : ''} onClick={() => setCurrentTab('licenceReport')}>
              <TbLicense className='reports-font-style-dark'/> Licence Report
            </button> */}
            <button className={currentTab === 'dailyReport' ? 'active' : ''} onClick={() => setCurrentTab('dailyReport')}>
              <FaChartBar className='reports-font-style-dark'/> Daily Report
            </button>
            <button className={currentTab === 'sotReport' ? 'active' : ''} onClick={() => setCurrentTab('sotReport')}>
              <FaChartBar className='reports-font-style-dark'/> SOT Report
            </button>
          </>
        )}
        <button className={currentTab === 'monitoringService' ? 'active' : ''} onClick={() => setCurrentTab('monitoringService')}>
          <MdMiscellaneousServices className='reports-font-style-dark'/> Monitoring Service
        </button>
        {/* <button className={currentTab === 'auditReport' ? 'active' : ''} onClick={() => setCurrentTab('auditReport')}>
          <FaChartBar className='reports-font-style-dark'/> Audit Report
        </button> */}
      </div>

      <Suspense fallback={<div className="report-loading">Loading report...</div>}>
        {currentTab === 'devices' && <DeviceTable />}
        {/* {currentTab === 'licenceReport' && <LicenceReport />} */}
        {currentTab === 'dailyReport' && <DailyReportPage />}
        {currentTab === 'sotReport' && <SOTReportPage />}
        {currentTab === 'auditReport' && <RecordsAuditReportPage />}
        {currentTab === 'monitoringService' && <MonitoringServiceReportPage />}
      </Suspense>
    </div>
  );
};

export default Reports;
